


































import {
  ComponentInternalInstance,
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from '@vue/composition-api';
import sendSMSRegister from '@/renderer/views/register/components/sendSMSRegister.vue';
import fillRegisterMessage from '@/renderer/views/register/components/fillRegisterMessage.vue';
import SettingDialog from '@/renderer/components/dialog/setting/index.vue';
import registerHandler from '@/renderer/views/register/compositions/registerHandler';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
export default defineComponent({
  name: 'register',
  components: {
    sendSMSRegister,
    fillRegisterMessage,
    SettingDialog,
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const showSetting = ref(false);
    const {
      isStepOne,
      formData,
      errMsg,
      invalidNameMsg,
      registerLoading,
      phoneMaxLen,
      smsText,
      isCounting,
      disabledFormItem,
      methods: registerMethods,
    } = registerHandler();
    const reporterMap: Record<string, string> = {
      share: 'link_share',
      invitation: 'invite',
      collect: 'document_collect',
      homepage: 'homepage',
      login: 'login',
      login_tips_pop_up: 'login_tips_pop_up',
    };
    const methods = {
      goLogin() {
        dispatchRouter(
          {
            name: 'login',
          },
          'replace',
        );
      },
      // 响应托盘菜单消息
      onTrayMenuEvent(e: Event, params: any) {
        const { event } = params;
        switch (event) {
          case 'update':
            ipc.emit(ipc.RENDERER_EVENTS_MAP.CHECK_UPDATE);
            break;
          case 'setting':
            showSetting.value = true;
            break;
          default:
            break;
        }
      },
    };
    onMounted(() => {
      const accessSource = vm.$route.query?.from as string;
      if (accessSource) {
        reporter.report('free_trial_version', {
          access_source: `${reporterMap[accessSource]}`,
        });
      }
      ipc.on(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    });
    onUnmounted(() => {
      ipc.off(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    });
    return {
      isStepOne,
      showSetting,
      formData,
      errMsg,
      invalidNameMsg,
      registerLoading,
      phoneMaxLen,
      smsText,
      isCounting,
      disabledFormItem,
      registerMethods,
      ...methods,
    };
  },
});
